import { DotsThreeVertical } from '@phosphor-icons/react';
import { useState } from 'react';
import { useTheme } from '@emotion/react';
import { ContextMenu, MenuOptionProps } from './ContextMenu';

type DotsMenuButtonProps = {
  menuOptions: MenuOptionProps[];
};

export const DotsMenuButton = ({ menuOptions }: DotsMenuButtonProps) => {
  const theme = useTheme();
  const [menuPosition, setMenuPosition] = useState<{ x: number; y: number } | null>(null);

  const isMenuOpen = Boolean(menuPosition);

  const handleDotsMenuClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation();

    setMenuPosition({ x: event.clientX, y: event.clientY + 8 });
  };

  const handleCloseMenu = () => {
    setMenuPosition(null);
  };
  return (
    <div
      className="dotsMenu"
      style={{ ...(isMenuOpen ? { display: 'flex' } : {}), position: 'relative', width: '18px' }}
    >
      <button className="dotsMenuBtn" onClick={handleDotsMenuClick}>
        <DotsThreeVertical
          data-testid="dots_icon"
          data-color={theme.palette.fg.secondary}
          data-size="16"
          color={theme.palette.fg.secondary}
          size={16}
        />
      </button>
      {menuPosition && (
        <ContextMenu
          {...{
            openMenu: Boolean(menuPosition),
            options: menuOptions,
            onClose: handleCloseMenu,
            menuPosition,
          }}
        />
      )}
    </div>
  );
};
